// filepath: c:\Users\2396375\assenivesh-ui\an-vue\src\screens\dashboard\KYCView.vue
<template>
  <KYCVerification />
</template>

<script>
import KYCVerification from '@/components/dashboard/KYCVerification.vue';

export default {
  name: "KYCView",
  components: {
    KYCVerification
  }
};
</script>

<style scoped>
/* Page-level styles if needed */
</style>
